import React from "react";
import { SiBloglovin } from "react-icons/si";
import "./styles.scss";
import { useState } from "react";
import PageHeader from "../../pageHeader";
import { Link } from "react-router-dom";
import { blogsInformation } from "./utils/bloginfo";

const filterData = [
  {
    filterId: "all",
    label: "All",
  },
  {
    filterId: "front-end",
    label: "Front End",
  },
  {
    filterId: "back-end",
    label: "Back End",
  },
  {
    filterId: "database",
    label: "Database",
  },
];

const Blogs = () => {
  const [filteredValue, setFilteredValue] = useState("all");
  const [hoveredValue, setHoveredValue] = useState(null);

  function handleFilter(currentId) {
    setFilteredValue(currentId);
  }

  function handleHover(index) {
    setHoveredValue(index);
  }

  const filteredItems =
    filteredValue === "all"
      ? blogsInformation
      : blogsInformation.filter((item) => item.id === filteredValue);

  let content;
  if (blogsInformation.filter((item) => item.id === filteredValue)) {
    content = filteredItems.map((item, index) => (
      <div
        className="blog__content__cards__item"
        key={`cardItem${item.name.trim()}`}
        onMouseEnter={() => handleHover(index)}
        onMouseLeave={() => handleHover(null)}
      >
        <div className="blog__content__cards__item__img-wrapper">
          <Link>
            <img alt={item.image + index} src={item.image} />
          </Link>
        </div>
        <div className="overlay">
          {index === hoveredValue && (
            <div>
              <p title={item.name.length > 25 ? item.name : ""}>
                {item.name.length > 25
                  ? item.name.slice(0, 25) + "..."
                  : item.name}
              </p>
              <div className="view-details">
                <Link to={item.link} className="view-details-btn">
                  View Details
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    ));
  } if(filteredItems.length<=0) {
    content = (
      <div className="div">
        <h1 className="no-blog">( No blogs available. See another category. )</h1>
      </div>
    );
  }

  // console.log(filteredItems);

  return (
    <section id="blog" className="blog">
      <PageHeader headerText="My Blogs" icon={<SiBloglovin size={40} />} />

      <div className="blog__content">
        <ul className="blog__content__filter">
          {filterData.map((item) => (
            <li
              className={item.filterId === filteredValue ? "active" : ""}
              onClick={() => handleFilter(item.filterId)}
              key={item.filterId}
            >
              {item.label}
            </li>
          ))}
        </ul>
        <div className="blog__content__cards">{content}</div>
      </div>
    </section>
  );
};
export default Blogs;
